import { pages } from 'config';

export const getPageFromState = (state) => {
  const pathname = state?.router?.location?.pathname;
  const page = pages.find((route) => route.pattern.test(pathname));
  return { name: page?.name };
};
